import { useState } from 'react'
import styled from 'styled-components'
import { Logo, NavBar } from '../../components/core'
import { Close } from '../../components/icons'
import Theme from '../../Theme'
import Video from './components/Video'

const Container = styled.div`
    height:100%;
    width:100%;
    position:relative;
`


const CloseWrap = styled.div`
    position: fixed;
    top: 0;
    right: 52px;
    padding: 20px;
    z-index:1;
    cursor: pointer;
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
        right: 0px;
    }
`

type Props = {
    timestamp: number
    changeScreen: () => void
    backToChapters: () => void
    backToSplit: any
    menuOpen: boolean
}

export default function Tour({ timestamp, changeScreen, backToSplit, menuOpen, backToChapters }: Props) {
    const [playing, setPlaying] = useState(true)

    return (
        <Container>
            <Video timestamp={timestamp} toMap={changeScreen} menuOpen={menuOpen} setPlaying={setPlaying} />
            <NavBar backToSplit={backToSplit} onClick={changeScreen} text='INTERACTIVE MAP' position={'right'} />

            {
                !playing && <a href='https://www.liuna.org/' target="_blank">
                    <Logo position="left" />
                </a>
            }

            <CloseWrap onClick={backToChapters}>
                <Close />
            </CloseWrap>
        </Container>
    )
}
